import { ProductSubDepartmentCreatePage } from "@/features/product-sub-department/pages/ProductSubDepartmentCreatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/product-sub-department/create")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_sub_department.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductSubDepartmentCreatePage,
});
